import { CartItem } from './cart';
import { CheckoutFormKey } from './checkout-form';
import { PriceType } from './equipment';
import { Order } from './order';
import { Quote } from './quotes';
import { TooltipType } from './tooltip';

export type CheckoutStepKey = CheckoutFormKey | 'review';

export enum RentalProtectionType {
  SELF = 'SELF',
  STANDARD = 'STANDARD',
}

export enum DeliveryOptionType {
  SELF = 'SELF',
  PAID = 'PAID',
}

export enum DropOffOptionType {
  SELF = 'SELF',
  PAID = 'PAID',
}

export enum ReceiverOptionType {
  SELF = 'SELF',
  OTHERS = 'OTHERS',
}

export type SummaryCartItem = CartItem & {
  total?: number;
  priceType?: PriceType;
};

export type CartSummaryLineKey = {
  id: string;
  description: string;
  tooltip?: TooltipType;
  getValue: (v: Quote) => number | undefined;
};

export type OrderSummaryLineKey = {
  id: string;
  description: string;
  tooltip?: TooltipType;
  getValue: (v: Order) => number | undefined;
};

export type CartSummaryLineItem = {
  id: string;
  description: string;
  amount?: number;
  tooltip?: TooltipType;
};
